import Cookies from "universal-cookie";
import ConfigService from "service/ConfigService";

const cookies = new Cookies();

export default class CookieService {
    static get(name) {
        return cookies.get(name);
    }

    // Matches the server access-token lifetime (SecurityConstants.EXPIRATION_TIME = 10 days). Sliding
    // renewal re-sets the cookie on active requests, so an active session keeps extending; an idle one
    // lapses with the token. (secure cookies can't be set on localhost, which has no https.)
    static TOKEN_MAX_AGE_SECONDS = 864000;

    static set = async (name, value, path = '/') => {
        const secure = await ConfigService.getConfigAsync('is_secure');
        // sameSite:'strict' stops the browser auto-sending this cookie on cross-site requests, which
        // closes cookie-driven CSRF on state-changing endpoints (the server also accepts the token from
        // this cookie). Auth is unaffected: the app reads the token via JS and sends it as the
        // Authorization header, and SameSite does not govern JS reads.
        cookies.set(name, value, {path, maxAge: CookieService.TOKEN_MAX_AGE_SECONDS, secure, sameSite: 'strict'});
    }

    static remove(name, path) {
        cookies.remove(name, {path});
    }
}